const style = (theme): any => ({
    root: {
        display: 'flex',
        '& .MuiToolbar-regular': {
            minHeight: 96,
        },
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
    },
    toolbar: {
        minHeight: 96,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        fontSize: '1.rem',
    },
    message: {
        paddingBottom: theme.spacing(3),
        textAlign: 'center',
    },
    login: {
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'center',
    },
    form: {
        width: '50%',
        textAlign: 'center',
    },
    formControl: {
        width: '100%',
        marginBottom: 14,
    },
    marginLeft: {
        marginLeft: 8,
        [theme.breakpoints.down('sm')]: {
            marginLeft: 0,
            marginTop: 8,
        },
    },
});
export default style;
